export enum SessionStorageKey {
  MODULE_LOAD_ERROR_COUNT = 'module_load_error_count',
}
